<template>
  <el-dialog
    title="支付"
    custom-class="MyDialog"
    :visible.sync="paymentFeesDialogVisible"
    :close-on-click-modal="false"
    @close="closePaymentFeesDialog"
    width="1000px"
  >
  <div>
    <div class="purchase-fees-info">
      <div class="textOne">
        <span>采购单号：{{ payData.orderNo }}</span>
        <span>下单时间：{{ payData.orderCreateTime }}</span>
      </div>
      <div class="textTwo">
        <span>采购量：{{ payData.buyNum }}台</span>
        <span>采购金额：
          <span :style="{ color: 'red' }">{{payData.orderAmount}}</span>
        </span>
        <span>实付金额：
          <span :style="{ color: 'red' }">{{payData.receivedAmount}}</span>
        </span>
      </div>
      <div class="programme-box">
        <p class="programme-title">运费方案：</p>
        <ul class="programme-ul">
          <li class="programme-1">
            方案一: 运费到付: <span class="programme-price">{{payData.freightOriginalAmount}}元</span>
            （收货后支付给配送员，实际金额可能会有20%的浮动，以实际为准）
          </li>
          <li>
            方案二: 运费预付: 
            <span class="programme-price">{{payData.freightAmount}}元</span>
            （原价{{payData.freightOriginalAmount}}元，与订货款一起支付，出现争议由总部负责）
          </li>
        </ul>
      </div>
    </div>
    <div class="charge-table">
      <MyTable
        :titleData="titleData1"
        :tableData="tableData1"
        :index="true"
        :indexMethod="indexMethod"
      ></MyTable>
    </div>
    <div class="fees-tips-wrap">
      <p class="action-title">本订单采购数量不足10台，按公司快递规则是: 到付;为了让大家享受邮费打折的优惠，现提供预付到付运费的服务，请注意:</p>
      <ul class="rules-ul">
        <li>
        1、到付运费折扣以公司与京东仓签订的折扣为准，目前折扣: 6.5折，以后如有变化，会及时通知;
        </li>
        <li>
        2、预收到付运费自愿选择，如果放弃预付运费所享受的折扣，须在签收时支付到付运费给快递公司，具体支付金额和方式以快递公司为准;
        </li>
        <li>
        3、预收到付运费收取后，如果此订单与其他订单合并配送，满足免运费条件(数量大于等于10台)，完成后，自动退还预收运费;
        </li>
      </ul>
    </div>
  </div>
    <span slot="footer" class="dialog-footer">
      <el-button  @click="closePaymentFeesDialog">取消</el-button>
      <el-button type="primary" @click="onlyOrderPay">支付(运费到付)</el-button>
      <el-button type="primary" @click="confirmButton">支付(运费预付)</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryOrderFreight, saveOrderFreight } from "@/api/AccountInterface";
import MyTable from "@/components/table.vue";

export default {
  data() {
    return {
      paymentFeesDialogVisible: false,
      titleData1: [
        {
          label: "收费项目",
          prop: "itemName",
          key: "itemName",
          align: "center"
          // fixed: 'left',
        },
        {
          label: "单价",
          prop: "price",
          key: "price",
          align: "center"
          // fixed: 'left',
        },
        {
          label: "数量",
          prop: "buyNum",
          key: "buyNum",
          align: "center"
          // fixed: 'left',
        },
        {
          label: "金额",
          prop: "originalAmount",
          key: "originalAmount",
          align: "center"
          // fixed: 'left',
        },
        {
          label: "折扣",
          prop: "rateName",
          key: "rateName",
          align: "center"
          // fixed: 'left',
        },
        {
          label: "优惠后的金额",
          prop: "amount",
          key: "amount",
          align: "center"
          // fixed: 'left',
        },
      ],
      tableData1: [],
      tableItems: [],
      payData: {},
    }
  },
  props: {
    showPaymentFeesDialog: {
      type: Boolean,
      default: false
    },
    orderNo: {
      type: String|Number,
      default: '',
    }
  },
  components: {
    MyTable,
  },
  watch: {
    showPaymentFeesDialog: {
      handler(newVal, oldVal) {
        console.log('newVal', newVal);
        this.paymentFeesDialogVisible = newVal;
      },
      immediate: true
    },
    // orderNo: {
    //   handler(newVal, oldVal) {
    //     this.paymentFeesDialogVisible = newVal;
    //   },
    //   immediate: true
    // },
  },
  mounted() {
    this.getOrderFreight();
  },
  methods: {
    getOrderFreight() {
      queryOrderFreight({orderNo: this.orderNo}).then(res => {
        if(res.code === 0) {
          this.payData = res.data;
          this.tableItems = res.data.items;
          let tableDataArr = JSON.parse(JSON.stringify(this.tableItems));
          tableDataArr.map(item => {
            if (item.itemName == '保费') {
              item['price'] = '';
              item['buyNum'] = '';
            }
          })
          this.tableData1 = tableDataArr;
        } else {
          this.payData = {};
          this.tableItems = [];
          this.$message.error(res.message || '请勿操作过于频繁');
        }
      })
    },
    saveOrderFreightHandler() {
      saveOrderFreight({
        orderNo: this.orderNo,
        items: this.tableData,
      }).then(ret => {
        if (ret.code === 0) {

        } else {
            this.$message.error(ret.message || '付款失败');
          }
        })
    },
    closePaymentFeesDialog() {
      this.paymentFeesDialogVisible = false;
      this.$emit('closePaymentFeesDialog');
    },
    indexMethod(index) {
      return index + 1;
    },
    onlyOrderPay() {
      saveOrderFreight({
        orderNo: this.orderNo,
        items: [],
      }).then(ret => {
        if (ret.code === 0) {
          this.paymentFeesDialogVisible = false;
          this.$emit('yufeidaofuSuccess');
      } else {
          this.$message.error(ret.message || '付款失败');
        }
      })
    },
    confirmButton() {
      saveOrderFreight({
        orderNo: this.orderNo,
        items: this.tableItems,
      }).then(ret => {
      if (ret.code === 0) {
        this.paymentFeesDialogVisible = false;
        this.$emit('yushouyunfeiSuccess');
      } else {
        this.$message.error(ret.message || '付款失败');
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.purchase-fees-info {
  color: #4A83E8;
  background: rgb(232, 243, 254);
  width: 100%;
  margin: 0 auto;
  border-radius: 10px;
  font-size: 14px;
  overflow: hidden;
  margin-bottom: 20px;

  .textOne {
    width: 90%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .textTwo {
    width: 90%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.programme-box {
  margin-top: 10px;
  margin-left: 50px;
  padding-bottom: 15px;
  color: #1890ff;
  .programme-title {
    font-weight: 500;
  }
  .programme-price {
    color: rgba(224, 58, 50, 1);
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .programme-ul {
    margin-top: 10px;
    margin-bottom: 0;
    .programme-1 {
      margin-bottom: 10px;
    }
  }
}

.fees-tips-wrap {
  margin-top: 20px;
  margin-bottom: 10px;
  .action-title {
    color: #1890ff;
    font-size: 14px;
  }
  .rules-ul {
    margin-top: 20px;
    li {
      color: #1890ff;
      font-size: 14px;
    }
  }
}
</style>